<template>
  <div v-if="visible" class="debug-modal-backdrop">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Depuración de Tablas - Tickets</h3>
        <button
          type="button"
          class="btn-close"
          @click="close"
          aria-label="Cerrar"
        >
          <span class="material-icons close-icon" aria-hidden="true">close</span>
        </button>
      </div>

  <!-- token input eliminado (se usa sessionStorage) -->

      <section class="modal-body">
        <form @submit.prevent="preview">
          <div class="row">
            <div style="display:flex;gap:12px;align-items:flex-start;width:100%;margin-top: 10px;">
              <!-- Fechas en columna (una debajo de otra) -->
              <div style="display:flex;flex-direction:column;gap:8px;">
                <label><b>Fecha desde</b></label>
                <input type="date" v-model="filters.fechaDesde" />
                <label><b>Fecha hasta</b></label>
                <input type="date" v-model="filters.fechaHasta" />
              </div>

              <div
                class="filters-inline"
                style="margin-left:auto; display:flex;flex-direction:column;gap:8px; min-width:260px;"
              >
                <label style="display:inline-flex; align-items:center; gap:8px;">
                  <input type="checkbox" v-model="filters.onlySoftDeleted" />
                  <span><b>Eliminados</b></span>
                </label>

                <!-- checkbox: seleccionar todos los estados -->
               
                <div>
                  <div style="font-weight:600;margin-bottom:6px;color: #333;"><b>Estados</b></div>
                   <label style="display:inline-flex; align-items:center; gap:8px;">
                  <input type="checkbox" v-model="allEstados" />
                  <span>Todos</span>
                </label>

                  <div style="display:flex;gap:6px;flex-wrap:wrap;">
                    <label
                      v-for="e in estadosOptions"
                      :key="e.id"
                      style="display:inline-flex;align-items:center;gap:6px;"
                    >
                      <input type="checkbox" :value="e.id" v-model="filters.estados" :disabled="allEstados" />
                      <span>{{ e.label }}</span>
                    </label>
                  </div>
                </div>


                <div>
                  <div style="font-weight:600;margin-bottom:6px"><b>Prioridades</b></div>
                                 <!-- checkbox: seleccionar todas las prioridades -->
                <label style="display:inline-flex; align-items:center; gap:8px;">
                  <input type="checkbox" v-model="allPrioridades" />
                  <span>Todas</span>
                </label>
                  <div style="display:flex;gap:6px;flex-wrap:wrap;">
                    <label
                      v-for="p in prioridadesOptions"
                      :key="p.id"
                      style="display:inline-flex;align-items:center;gap:6px;"
                    >
                      <input type="checkbox" :value="p.id" v-model="filters.prioridades" :disabled="allPrioridades" />
                      <span>{{ p.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Paginar desde el backend: perPage/page eliminados del UI -->
           </div>

          <div class="actions">
            <button type="button" class="btn btn-preview" @click="preview">Previsualizar</button>
            <button type="button" class="btn btn-delete" @click="executeSelected" :disabled="selectedIds.length===0">Borrar seleccionados</button>
          </div>
        </form>

        <div class="candidates" v-if="candidates.length">
          <table>
            <thead>
              <tr>
                <th><input type="checkbox" @change="toggleAll($event)" :checked="allSelected" /></th>
                <th>ID</th>
                <th>Fecha creación</th>
                <th>Usuario</th>
                <th>Borrado</th>
                <th>Estado</th>
                <th>Prioridad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in candidates" :key="item.id">
                <td><input type="checkbox" :value="item.id" v-model="selectedIds" /></td>
                <td>{{ item.id }}</td>
                <td>{{ item.fecha_creacion }}</td>
                <td>{{ item.usuario_id }}</td>
                <td class="col-borrado">
                  <!-- Material icon: aspa 'close' (puedes cambiar por 'check' si prefieres) -->
                  <span v-if="Number(item.borrado) === 1" class="borrado-iconify material-icons" title="Borrado" aria-hidden="true">close</span>
                </td>
                <td>{{ getEstadoLabel(item.estado_id) }}</td>
                <td>{{ getPrioridadLabel(item.prioridad_id) }}</td>
              </tr>
            </tbody>
          </table>
 
          <!-- paginación en UI eliminada (se usa la lista que devuelva el backend) -->
         </div>

        <!-- serverResponse eliminado: los mensajes se muestran con SweetAlert -->
      </section>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import Swal from 'sweetalert2';
 
 export default {
   name: 'TableManagementDebugDatabaseModalView',
   created() {
     const existing = sessionStorage.getItem('api_token') || sessionStorage.getItem('token') || null;
     console.debug('[DebugDatabase] token from sessionStorage (modal):', existing);
     if (existing) api.defaults.headers.common['Authorization'] = 'Bearer ' + existing;
   },
   props: { visible: { type: Boolean, default: false } },
    data() {
     return {
       tokenInput: sessionStorage.getItem('api_token') || sessionStorage.getItem('token') || '',
       filters: {
         fechaDesde: '',
         fechaHasta: '',
         onlySoftDeleted: false,
         estados: [],
         prioridades: []
       },
      // flags para "seleccionar todos"
      allEstados: false,
      allPrioridades: false,
       list: true,
       perPage: 50,
       page: 1,
       candidates: [],
       selectedIds: [],
       summary: null,
       serverMessage: null,
       estadosOptions: [
         { id: 1, label: 'Abiertos' },
         { id: 2, label: 'En Proceso' },
         { id: 3, label: 'Cerrados' }
       ],
       prioridadesOptions: [ { id:1, label:'Baja' }, { id:2, label:'Media' }, { id:3, label:'Alta' } ],
     };
   },
   computed: {
     summaryCount() {
       return (this.summary && this.summary.count) || (this.summary && this.summary.tickets && this.summary.tickets.count) || 0;
     },
     summaryTicketsAppliedFilters() {
       return (this.summary && this.summary.tickets && this.summary.tickets.appliedFilters) || null;
     },
     allSelected() {
       return this.candidates.length > 0 && this.selectedIds.length === this.candidates.length;
     },
     totalPages() {
       const total = (this.summary && this.summary.tickets && this.summary.tickets.candidates && this.summary.tickets.candidates.total) || 0;
       return Math.max(1, Math.ceil(total / this.perPage));
     },
     canExecute() {
       return true;
     },
     hasToken() {
       return !!(sessionStorage.getItem('api_token') || sessionStorage.getItem('token'));
     }
   },
   watch: {
     visible(val) {
       if (!val) this.reset();
     },
    // si el usuario marca "todos", limpiar arrays para que no se envíen como filtro
    allEstados(val) {
      if (val) this.filters.estados = [];
    },
    allPrioridades(val) {
      if (val) this.filters.prioridades = [];
    },
     // Cuando cambien los filtros, volver a la página 1 (no lanzar preview automáticamente)
     filters: {
       handler() {
         this.page = 1;
       },
       deep: true
     }
   },
   methods: {
     // cerrar el modal: emitir update:visible para v-model y evento 'close' por compatibilidad
     close() {
       this.$emit('update:visible', false);
       this.$emit('close');
     },
    /**
     * Devuelve la etiqueta/nombre de un estado por su id.
     */
     getEstadoLabel(id) {
       const s = this.estadosOptions.find(e => e.id === id);
       return s ? s.label : id;
     },
     /**
      * Devuelve la etiqueta/nombre de una prioridad por su id.
      */
     getPrioridadLabel(id) {
       const p = this.prioridadesOptions.find(x => x.id === id);
       return p ? p.label : id;
     },
     saveToken() {
       if (!this.tokenInput) { this.serverMessage = 'Token vacío'; return; }
       sessionStorage.setItem('api_token', this.tokenInput);
       api.defaults.headers.common['Authorization'] = 'Bearer ' + this.tokenInput;
       this.serverMessage = 'Token guardado en sessionStorage.';
     },
     clearToken() {
       sessionStorage.removeItem('api_token');
       sessionStorage.removeItem('token');
       delete api.defaults.headers.common['Authorization'];
       this.tokenInput = '';
       this.serverMessage = 'Token borrado.';
     },
     /**
      * Establece los parámetros del componente según el JSON recibido.
      * Uso: this.setQueryFromJson(obj); luego this.preview();
      */
     setQueryFromJson(cfg) {
       if (!cfg || typeof cfg !== 'object') return;
       const t = cfg.targets && cfg.targets.tickets ? cfg.targets.tickets : null;
       if (t) {
         this.filters.fechaDesde = t.fechaDesde || '';
         this.filters.fechaHasta = t.fechaHasta || '';
         this.filters.estados = Array.isArray(t.estados) ? t.estados.slice() : [];
         this.filters.prioridades = Array.isArray(t.prioridades) ? t.prioridades.slice() : [];
       }
       this.list = !!cfg.list;
       this.perPage = Number.isInteger(cfg.perPage) ? cfg.perPage : this.perPage;
       this.page = Number.isInteger(cfg.page) ? cfg.page : this.page;
     },

     // Cargar preset fijo en UI
     loadPreset() {
       const q = {
         targets: {
           tickets: {
             enabled: true,
             fechaDesde: "2025-10-31",
             fechaHasta: "2025-10-31",
             estados: [1,2,3],
             prioridades: [1,2,3]
           }
         },
         list: true,
         perPage: 50,
         page: 1
       };
       this.setQueryFromJson(q);
       this.serverMessage = 'Preset cargado.';
     },
     async loadAndPreview() {
       this.loadPreset();
       await this.preview();
     },
     // Establece un JSON mínimo con solo fechas (según tu ejemplo)
     loadSimpleRange() {
       const q = {
         targets: {
           tickets: {
             enabled: true,
             fechaDesde: "2025-01-01",
             fechaHasta: "2025-10-31"
           }
         }
       };
       this.setQueryFromJson(q);
       this.serverMessage = 'Rango simple cargado.';
     },
     // Carga y previsualiza con el JSON mínimo
     async loadSimpleAndPreview() {
       this.loadSimpleRange();
       await this.preview();
     },
     getAuthHeaders() {
      const tok = sessionStorage.getItem('api_token') || sessionStorage.getItem('token') || null;
      if (tok) return { Authorization: 'Bearer ' + tok };
      return {};
    },
    async ensureAuth() {
      const tok = sessionStorage.getItem('api_token') || sessionStorage.getItem('token') || null;
      if (tok) return { mode: 'bearer' };
      try {
        // Usar fetch para llamar a "/sanctum/csrf-cookie" en la raíz del host
        // con credentials para que Laravel/Sanctum deje la cookie.
        const res = await fetch('/sanctum/csrf-cookie', {
          method: 'GET',
          credentials: 'include'
        });
        if (!res.ok) {
          this.serverMessage = `CSRF cookie request failed: ${res.status} ${res.statusText}`;
          return null;
        }
        return { mode: 'sanctum' };
      } catch (e) {
        this.serverMessage = 'No autenticado: fallo petición CSRF cookie.';
        return null;
      }
    },
     buildTargets() {
       const t = { tickets: {} };
       const hasFecha = !!this.filters.fechaDesde || !!this.filters.fechaHasta;
       const hasSoft = this.filters.onlySoftDeleted === true;
      // considerar "Todos" como válido para la validación (pero no enviarlo al backend)
      const hasEstados = this.allEstados || (Array.isArray(this.filters.estados) && this.filters.estados.length > 0);
      const hasPri = this.allPrioridades || (Array.isArray(this.filters.prioridades) && this.filters.prioridades.length > 0);

       // Ahora: las fechas son obligatorias. Activar solo si hay fechas Y (estados/prioridades/soft).
       const hasAnyFilter = hasSoft || hasEstados || hasPri;
       t.tickets.enabled = !!(hasFecha && hasAnyFilter);
       if (!t.tickets.enabled) return { targets: t };

       // incluir fechas (ya sabemos que existe al menos una)
       if (this.filters.fechaDesde) t.tickets.fechaDesde = this.filters.fechaDesde;
       if (this.filters.fechaHasta) t.tickets.fechaHasta = this.filters.fechaHasta;
       if (hasSoft) t.tickets.onlySoftDeleted = true;
      // enviar estados/prioridades SOLO si NO está marcado "Todos"
      if (!this.allEstados && Array.isArray(this.filters.estados) && this.filters.estados.length) t.tickets.estados = this.filters.estados.slice();
      if (!this.allPrioridades && Array.isArray(this.filters.prioridades) && this.filters.prioridades.length) t.tickets.prioridades = this.filters.prioridades.slice();
       return { targets: t };
     },
     async preview() {
       this.serverMessage = null;
       const body = this.buildTargets();
      // Si no hay target activo (fechas obligatorias + filtros), mostrar aviso con SweetAlert y no llamar al backend.
      if (!body.targets || !body.targets.tickets || !body.targets.tickets.enabled) {
        const msg = 'No se enviará petición: las fechas (desde/hasta) son obligatorias y debe marcar al menos estados, prioridades o "Only soft deleted".';
        // botón de confirmación en color corporativo
        Swal.fire({ title: 'Aviso', text: msg, icon: 'warning', confirmButtonText: 'Cerrar', confirmButtonColor: '#99172A' });
        this.candidates = [];
        this.summary = null;
        return;
      }
      const auth = await this.ensureAuth();
      if (!auth) return;
      body.list = this.list;
      body.perPage = this.perPage;
      body.page = this.page;
      
      try {
         console.debug('[preview] body:', body);
         const headers = this.getAuthHeaders();
         console.debug('[preview] headers:', headers);
         const res = await api.post('/debug/preview-purge', body, { headers });
         this.summary = res.data.summary || res.data;
         if (this.summary.tickets) {
           const t = this.summary.tickets;
           if (t.candidates && t.candidates.data) {
             this.candidates = t.candidates.data;
           } else if (t.sample) {
             this.candidates = t.sample;
           } else {
             this.candidates = [];
           }
           this.summary.appliedFilters = t.appliedFilters || (this.summary.appliedFilters || null);
         } else {
           this.candidates = [];
         }
         // Mantener la selección: eliminar sólo los ids que ya no están en los candidatos actuales
         if (this.selectedIds && this.selectedIds.length) {
           const currentIds = new Set(this.candidates.map(i => i.id));
           this.selectedIds = this.selectedIds.filter(id => currentIds.has(id));
         }
      } catch (err) {
        this.serverMessage = (err.response && err.response.data) ? JSON.stringify(err.response.data, null, 2) : String(err);
      }
    },
    async executeSelected() {
      const KEYWORD = 'ELIMINAR';
      const result = await Swal.fire({
        title: 'Confirmar borrado (IRREVERSIBLE)',
        html: `
          <p style="margin-bottom:8px;">Esta operación es <strong style="color:#b12b34;">IRREVERSIBLE</strong> — se eliminarán permanentemente los registros seleccionados y los archivos asociados.</p>
          <p>Escribe <strong>${KEYWORD}</strong> para confirmar el borrado.</p>
        `,
        icon: 'warning',
        input: 'text',
        inputPlaceholder: KEYWORD,
        showCancelButton: true,
        confirmButtonText: 'Borrar (IRREVERSIBLE)',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#b12b34',
        reverseButtons: true,
        inputValidator: (value) => {
          if (value === KEYWORD) return null;
          return `Debes escribir "${KEYWORD}" para confirmar.`;
        }
      });
      if (!result.isConfirmed) return;

      const auth = await this.ensureAuth();
      if (!auth) return;

      // usar el formato requerido: targets.tickets.ids = [...]
      const body = {
        targets: {
          tickets: { enabled: true, ids: this.selectedIds.slice() },
          ticket_files: { enabled: true },
          ticket_logs:  { enabled: true }
        },
        confirm: true,
        batchSize: 1000
      };

      const headers = this.getAuthHeaders();
      try {
        const res = await api.post('/debug/execute-purge', body, { headers });
        // Mostrar confirmación; al aceptar cerramos el modal
        await Swal.fire({ title: 'Borrado', text: 'Registros borrados correctamente.', icon: 'success', confirmButtonColor: '#99172A' });
        this.close();
        await this.preview();
      } catch (err) {
        const text = (err.response && err.response.data) ? JSON.stringify(err.response.data, null, 2) : String(err);
        Swal.fire({ title: 'Error', text, icon: 'error', confirmButtonColor: '#99172A' });
      }
    },
    async executeByFilters() {
      const KEYWORD = 'ELIMINAR';
      const result = await Swal.fire({
        title: 'Confirmar borrado (IRREVERSIBLE)',
        html: `
          <p>Vas a eliminar todos los registros que cumplen los filtros aplicados. Esta acción es <strong style="color:#b12b34;">IRREVERSIBLE</strong>.</p>
          <p>Escribe <strong>${KEYWORD}</strong> para confirmar.</p>
        `,
        icon: 'warning',
        input: 'text',
        inputPlaceholder: KEYWORD,
        showCancelButton: true,
        confirmButtonText: 'Borrar (IRREVERSIBLE)',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#b12b34',
        reverseButtons: true,
        inputValidator: (value) => {
          if (value === KEYWORD) return null;
          return `Debes escribir "${KEYWORD}" para confirmar.`;
        }
      });
      if (!result.isConfirmed) return;

      const auth = await this.ensureAuth();
      if (!auth) return;
      const body = this.buildTargets();
      body.batchSize = this.perPage;
      body.confirm = true;
      console.debug('[executeByFilters] body:', body);
      const headers = this.getAuthHeaders();
      console.debug('[executeByFilters] headers:', headers);
      try {
        const res = await api.post('/debug/execute-purge', body, { headers });
        // avisar y cerrar modal al confirmar
        await Swal.fire({ title: 'Hecho', text: `Registros borrados: ${res.data.results?.tickets?.deleted ?? res.data.deleted ?? 0}`, icon: 'success', confirmButtonColor: '#99172A' });
        this.close();
        await this.preview();
      } catch (err) {
        this.serverMessage = (err.response && err.response.data) ? JSON.stringify(err.response.data, null, 2) : String(err);
      }
    },
    toggleAll(event) {
      if (event.target.checked) this.selectedIds = this.candidates.map(i => i.id);
      else this.selectedIds = [];
    },
    changePage(p) {
      if (p < 1) p = 1;
      if (p > this.totalPages) p = this.totalPages;
      this.page = p;
      this.preview();
    },
    reset() {
      this.filters = { fechaDesde:'', fechaHasta:'', onlySoftDeleted:false, estados:[], prioridades:[] };
      this.list = true;
      this.perPage = 50;
      this.page = 1;
      this.candidates = [];
      this.selectedIds = [];
      this.summary = null;
      this.serverMessage = null;
    }
  }
 };
</script>

<style scoped>
.debug-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.modal-content {
  background-color: #fff;
  border-radius: 12px;
  width: 700px;
  max-width: 95vw;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 1000;
  max-height: 90vh;
}

.modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #99172A;
  color: #fff;
  padding: 12px 48px;
  width: 100%;
  box-sizing: border-box;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  position: sticky;
  top: 0;
  z-index: 20;
}

.modal-title {
  margin: 0;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* botón de cierre: posición absoluta dentro del header, centrado verticalmente */
.btn-close {
  background: rgba(0,0,0,0.12);
  border: none;
  cursor: pointer;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.95;
  transition: opacity 0.12s, background-color 0.12s;
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 40;
}

.btn-close:hover {
  opacity: 1;
  background: rgba(0,0,0,0.18);
}

/* Material icon tamaño/color */
.close-icon {
  font-size: 20px;
  line-height: 1;
  color: #ffffff;
  display: inline-block;
  transform: translateY(1px);
}

.modal-body {
  padding: 0 28px 28px 28px;
  overflow: visible;
}

.row {
  display: flex;
  gap: 8px;
  margin: 8px 0;
  flex-wrap: wrap;
  align-items: center;
}

/* Focus rojo corporativo homogéneo */
/* aplicar solo a inputs/selects/textarea y controles de fecha, no a botones */
input:focus,
textarea:focus,
select:focus,
.row input[type="date"]:focus,
input[type="date"]:focus {
  outline: none;
  border-color: #99172A;
  box-shadow: 0 0 0 4px rgba(153,23,42,0.08);
  background: #fff;
}

/* checkboxes: accent + foco visible (se mantiene) */
input[type="checkbox"] {
  accent-color: #99172A;
}

input[type="checkbox"]:focus-visible {
  outline: 3px solid rgba(153,23,42,0.18);
  outline-offset: 2px;
  border-radius: 4px;
}

/* iconos/material-icons foco */
.material-icons:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(153,23,42,0.08);
  border-radius: 4px;
}

/* fila seleccionada / foco dentro de la tabla */
table tr:focus-within,
table tr:hover {
  background: rgba(153,23,42,0.03);
}

/* enlaces foco */
a:focus {
  outline: 3px solid rgba(153,23,42,0.12);
  outline-offset: 2px;
}

/* Inputs de fecha: borde y foco en color corporativo */
.row input[type="date"],
input[type="date"] {
  width: 150px;
  padding: 6px 8px;
  box-sizing: border-box;
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.row input[type="date"]:focus,
input[type="date"]:focus {
  outline: none;
  border-color: #99172A;
  box-shadow: 0 0 0 3px rgba(153,23,42,0.08);
}

/* ajustar controles en pantallas pequeñas */
@media (max-width:720px) {
  .modal-content {
    width: 95%;
    max-width: 720px;
    padding: 10px;
  }
  
  .row input[type="date"] {
    width: 120px;
  }
}

/* botón Previsualizar en color corporativo */
.btn-preview {
  background-color: #99172A;
  color: #fff;
  border: 1px solid #99172A;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-preview:hover {
  background-color: #7a111f;
  border-color: #7a111f;
}

/* botón Borrar seleccionados: mismo estilo pero gris */
.btn-delete {
  background-color: #6c757d;
  color: #fff;
  border: 1px solid #6c757d;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-delete:hover {
  background-color: #5a6268;
  border-color: #5a6268;
}

.btn-delete:disabled,
.btn-delete[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #6c757d;
  border-color: #6c757d;
}

.actions {
  margin: 12px 0;
  display: flex;
  gap: 8px;
}

/* Zona de resultados (tabla) scrollable: */
.candidates {
  width: 100%;
  max-height: calc(70vh - 120px);
  overflow-y: auto;
  margin-bottom: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: left;
}

/* Si quieres la cabecera de la tabla siempre visible dentro del scroll */
table thead tr th {
  position: sticky;
  top: 0;
  background: #f8f9fa;
  z-index: 10;
}

.col-borrado {
  text-align: center;
  width: 56px;
}

/* Material icon style for borrado */
.borrado-iconify {
  color: #99172A;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Estilos para paginación (aunque están ocultos) */
.pagination {
  margin-top: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.top-pagination {
  margin-bottom: 8px;
}

.server-response pre {
  background: #111;
  color: #fff;
  padding: 8px;
  overflow: auto;
  max-height: 200px;
}
</style>